import Twemoji from "react-twemoji";
import { clsObj } from "client-util/util";
import { PuzzleLink } from "components/Link";
import Tooltip from "components/Tooltip";
import PuzzleContentDisplay from "components/PuzzleContent/PuzzleContentDisplay";
import { useAccessiblePuzzles } from "stores/ScopeStateStore";
import { useState } from "react";
import "./TheWebSolution.css";
import {
  PUZZLES,
  PIECES,
  PIECE_ALT_NAME,
  POINTING_TO,
} from "sockapi/site-data";

export const SitePiecePreview = ({ puzName }: { puzName: string }) => {
  const isUnlocked = puzName in (useAccessiblePuzzles() ?? {});
  return (
    <Tooltip
      style={{ display: "inline-block" }}
      into
      disableTooltips={!isUnlocked}
      text={
        <div
          style={{
            width: "300px",
            height: "300px",
            color: "var(--body-text-color)",
            overflow: "auto",
            position: "relative",
          }}
          className="piece-view"
        >
          <PuzzleContentDisplay puzName={puzName} fontSize="12px" />
        </div>
      }
    >
      <PuzzleLink subpage="piece" puzName={puzName} />
    </Tooltip>
  );
};

export const SitePieceList = ({ puzName }: { puzName: string }) => {
  const index = PUZZLES.findIndex((p) => p === puzName);
  const pieces = PIECES.filter(([_, puzzles]) => puzzles[index] === 1);

  return (
    <ul>
      {pieces.map(([pieceName, _]) => (
        <li key={pieceName}>
          <SitePiecePreview puzName={pieceName} />
        </li>
      ))}
    </ul>
  );
};

export const TheWebFigure = ({ n }: { n: number }) => {
  const [puzzleHover, setPuzzleHover] = useState<string>();
  const [pieceHover, setPieceHover] = useState<string>();

  return (
    <div
      className="the-web-figure"
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "1em",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <table>
        <tbody>
          {Array(5)
            .fill(null)
            .map((_, i) => (
              <tr key={i}>
                {Array(5)
                  .fill(null)
                  .map((_, j) => {
                    const [pieceName, puzzles] = PIECES[5 * i + j];
                    return (
                      <td
                        key={j}
                        className={clsObj({
                          hover:
                            pieceHover === pieceName ||
                            (n === 2
                              ? !!pieceHover &&
                                (POINTING_TO[
                                  pieceHover as keyof typeof POINTING_TO
                                ] === pieceName ||
                                  !!Object.entries(POINTING_TO).find(
                                    ([key, value]) =>
                                      value === pieceHover && key === pieceName
                                  ))
                              : puzzleHover
                                ? !!puzzles[
                                    PUZZLES.findIndex((p) => p === puzzleHover)
                                  ]
                                : false),
                        })}
                        onPointerEnter={() => setPieceHover(pieceName)}
                        onPointerLeave={() => setPieceHover(undefined)}
                      >
                        {n === 0 ? (
                          <Twemoji>❓</Twemoji>
                        ) : (
                          ((n >= 2
                            ? PIECE_ALT_NAME[
                                pieceName as keyof typeof PIECE_ALT_NAME
                              ]
                            : null) ?? (
                            <PuzzleLink subpage="piece" puzName={pieceName} />
                          ))
                        )}
                      </td>
                    );
                  })}
              </tr>
            ))}
        </tbody>
      </table>
      {n <= 1 && (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: "0.5em",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {PUZZLES.map((puzName, i) => {
            const pieces = PIECES.filter(([, pieces]) => pieces[i]).map(
              ([pieceName]) => pieceName
            );
            return (
              <div
                key={puzName}
                className={clsObj({
                  hover:
                    puzzleHover === puzName ||
                    (!!pieceHover && pieces.includes(pieceHover)),
                })}
                onPointerEnter={() => setPuzzleHover(puzName)}
                onPointerLeave={() => setPuzzleHover(undefined)}
              >
                <PuzzleLink subpage="puzzle" puzName={puzName} />
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
